import { render, staticRenderFns } from "./FluxoAtendimentos.vue?vue&type=template&id=d7b86fc2&"
import script from "./FluxoAtendimentos.vue?vue&type=script&lang=js&"
export * from "./FluxoAtendimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7b86fc2')) {
      api.createRecord('d7b86fc2', component.options)
    } else {
      api.reload('d7b86fc2', component.options)
    }
    module.hot.accept("./FluxoAtendimentos.vue?vue&type=template&id=d7b86fc2&", function () {
      api.rerender('d7b86fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FluxoAtendimentos.vue"
export default component.exports